import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client/react";
import { gql } from "../../__generated__";
import { useRequiredParams } from "../../utils/hooks/use-required-params";
import PathConstants from "../../routes/path-constants";

export const SUBMITTED_GATE_QUERY = gql(`
  query SubmittedGate($appealId: ID!) {
    appealStatus(appealId: $appealId) {
      appealSubmitted
    }
  }
`);

export function SubmittedGate() {
  const { appealId } = useRequiredParams<"appealId">();
  const navigate = useNavigate();

  const { loading, data } = useQuery(SUBMITTED_GATE_QUERY, {
    variables: { appealId },
    fetchPolicy: "no-cache",
  });

  const appealSubmitted = data?.appealStatus?.appealSubmitted;

  const purchaseCompletePath =
    PathConstants.MyAppealsFinalizePurchaseComplete.replace(
      ":appealId",
      appealId,
    );

  useEffect(() => {
    if (appealSubmitted) {
      navigate(purchaseCompletePath, { replace: true });
    }
  }, [appealSubmitted, purchaseCompletePath, navigate]);

  if (loading) return null;

  return <Outlet />;
}
